<template>
  <div :class="$style.focalPicker">
    <div :class="$style.imageWrap">
      <img v-if="imageSrc" :src="imageSrc" class="img-fluid" :class="$style.image">
      <div :class="$style.grid">
        <button
          v-for="point in points"
          :key="point.x + '-' + point.y"
          type="button"
          :class="[$style.cell, { [$style.active]: point.x === value.x && point.y === value.y }]"
          :title="point.label"
          @click="$emit('input', { x: point.x, y: point.y })"
        >
          <span :class="$style.dot"></span>
        </button>
      </div>
    </div>
    <small class="d-block mt-2 text-muted">Klikni na místo, které se má při ořezu na menších obrazovkách vždy zůstat vidět.</small>
  </div>
</template>

<script>
export default {
  name: 'focal-point-picker',
  props: {
    imageSrc: {
      type: String,
      default: null,
    },
    value: {
      type: Object,
      default: () => ({ x: 50, y: 50 }),
    },
  },
  data() {
    return {
      points: [
        { x: 0, y: 0, label: 'Vlevo nahoře' },
        { x: 50, y: 0, label: 'Nahoře' },
        { x: 100, y: 0, label: 'Vpravo nahoře' },
        { x: 0, y: 50, label: 'Vlevo' },
        { x: 50, y: 50, label: 'Střed' },
        { x: 100, y: 50, label: 'Vpravo' },
        { x: 0, y: 100, label: 'Vlevo dole' },
        { x: 50, y: 100, label: 'Dole' },
        { x: 100, y: 100, label: 'Vpravo dole' },
      ],
    }
  },
}
</script>

<style lang="scss" module>
.focalPicker {
  max-width: 320px;
}

.imageWrap {
  position: relative;
  display: inline-block;
  width: 100%;
}

.image {
  width: 100%;
  display: block;
  border-radius: 4px;
}

.grid {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(3, 1fr);
}

.cell {
  border: 1px dashed rgba(255, 255, 255, .6);
  background: rgba(0, 0, 0, .12);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  transition: background-color .15s ease;

  &:hover {
    background: rgba(0, 0, 0, .28);
  }

  &.active {
    background: rgba(24, 144, 255, .35);
  }
}

.dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 0 0 2px rgba(0, 0, 0, .45);
  opacity: 0;
}

.active .dot {
  opacity: 1;
}
</style>
